module.exports = __webpack_public_path__ + "static/media/ProximaNova-ThinIt.2b8aab37.ttf";